/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_appsync_graphqlEndpoint": "https://fsewstanbfd7labr4qhdwdphla.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "eu-central-1:9f2c369f-6ce9-4017-b2b9-582d09213536",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_2IRxpBPVv",
    "aws_user_pools_web_client_id": "7noh2366f7s4vnh7bblmudut8a",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "supervisor3a6bf2fe6f704919adbed532349a5e4a113600-qa",
    "aws_user_files_s3_bucket_region": "eu-central-1"
};


export default awsmobile;
